import type { ComponentProps } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Text } from '@rtkwlf/fenrir-react';
import { faTrash } from '@rtkwlf/pro-solid-svg-icons/faTrash';
import { useTranslation } from 'react-i18next';

import {
  ConfirmationDialog,
  Appearances,
} from '@packages/components/confirmation-dialog/confirmation-dialog';

type props = {
  variant: ComponentProps<typeof Button>['variant'];
  actionOnClick: () => void;
};

export const DeleteConfirmationDialog = ({ variant, actionOnClick }: props) => {
  const { t } = useTranslation('telemetryScannerConfig');

  return (
    <ConfirmationDialog
      trigger={
        <Button
          appearance={Appearances.Danger}
          variant={variant}
          iconLeft={<FontAwesomeIcon icon={faTrash} />}
        >
          {t('ui:button.delete')}
        </Button>
      }
      title={t('deleteScanExclusionDialog.title')}
      description={<Text>{t('deleteScanExclusionDialog.content')}</Text>}
      actionText={t('deleteScanExclusionDialog.confirmationButton')}
      actionAppearance={Appearances.Danger}
      actionOnClick={actionOnClick}
    />
  );
};
